import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import "./MarketPosition.css";
import EndUserCustomerSegmentPenetration from "./EndUserCustomerSegmentPenetration";
import IndustrySegmentReach from "./IndustrySegmentReach";
import KeyExpansionsEmergingStrategicBets from "./KeyExpansionsEmergingStrategicBets";
import RecentStrategicCustomerWins from "./RecentStrategicCustomerWins";
import TrendingIndustrySignals from "./TrendingIndustrySignals";
import CustomerOverlapRiskZones from "./CustomerOverlapRiskZones";
import TopRightActionLinks from "../TopRightActionLinks";
import {
  getAllPageInsights,
  getAllSubdimensionMatches,
} from "../../../../services/commonService";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";

function MarketPosition() {
  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [industryAndSegmentReach, setIndustryAndSegmentReach] = useState([]);
  const [
    keyExpansionsAndEmergingStrategicBets,
    setKeyExpansionsAndEmergingStrategicBets,
  ] = useState([]);
  const [recentStrategicCustomerWins, setRecentStrategicCustomerWins] =
    useState([]);
  const [trendingIndustrySignals, setTrendingIndustrySignals] = useState([]);
  const [customerOverlapRiskZones, setCustomerOverlapRiskZones] = useState([]);
  const dispatch = useDispatch();

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(
      submitCorporateAndOrgStructureRequest(
        "Market Position & Customer Intelligence",
        clientName
      )
    );
  }, []);

  useEffect(() => {
    const tempIndustrySegmentReach = getAllSubdimensionMatches(
      data,
      "Industry & Segment Reach"
    );
    setIndustryAndSegmentReach(tempIndustrySegmentReach);

    const tempKeyExpansionsAndEmergingStrategicBets = getAllSubdimensionMatches(
      data,
      "Key Expansions & Emerging Strategic Bets"
    );
    setKeyExpansionsAndEmergingStrategicBets(
      tempKeyExpansionsAndEmergingStrategicBets
    );

    const tempRecentStrategicCustomerWins = getAllSubdimensionMatches(
      data,
      "Recent Strategic Customer Wins"
    );
    setRecentStrategicCustomerWins(tempRecentStrategicCustomerWins);

    const tempTrendingIndustrySignals = getAllSubdimensionMatches(
      data,
      "Trending Industry Signals"
    );
    setTrendingIndustrySignals(tempTrendingIndustrySignals);

    const tempCustomerOverlapRiskZones = getAllSubdimensionMatches(
      data,
      "Customer Overlap & Risk Zones"
    );
    setCustomerOverlapRiskZones(tempCustomerOverlapRiskZones);

    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);

  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div>
      <div className="market_position_wrapper">
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <InsightBlock
            title={"Market Position & Customer Intelligence"}
            overview={
              "A benchmarking to compare competitors on industry penetration, customer traction, and strategic moves."
            }
            actions={actions}
            pagePositives={pagePositives}
            pageNegatives={pageNegatives}
            pageSoWhat={pageSoWhat}
          />
        )}

        {/* <EndUserCustomerSegmentPenetration /> */}
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <IndustrySegmentReach
            industryAndSegmentReach={industryAndSegmentReach}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <KeyExpansionsEmergingStrategicBets
            keyExpansionsAndEmergingStrategicBets={
              keyExpansionsAndEmergingStrategicBets
            }
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <RecentStrategicCustomerWins
            recentStrategicCustomerWins={recentStrategicCustomerWins}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <TrendingIndustrySignals
            trendingIndustrySignals={trendingIndustrySignals}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <CustomerOverlapRiskZones
            customerOverlapRiskZones={customerOverlapRiskZones}
          />
        )}
      </div>

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default MarketPosition;
